module.exports = __webpack_public_path__ + "assets/img/103.cc707642.png";